import Markdown from "components/markdown/Markdown";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import useTypedContext from "hooks/useTypedContext";
import PageInfoHeader from "ds/components/PageInfoHeader";

import { ProviderVersionDocsContext } from "./Context";

const ProviderVersionDocsChangelog = () => {
  const { version } = useTypedContext(ProviderVersionDocsContext);

  return (
    <>
      <PageInfoHeader title="Changelog" />
      {!version.description ? (
        <EmptyState title="No changelog available for this version" />
      ) : (
        <Box padding="large" fullWidth>
          <Markdown markup={version.description} />
        </Box>
      )}
    </>
  );
};

export default ProviderVersionDocsChangelog;
